// @ts-nocheck
import { create } from "zustand";
import {
  isSpeechRecognitionSupported,
  isSpeechRecognitionAudioTrackSupported,
  getTranscriptionLang,
  setTranscriptionLang,
  getCustomerTranscriptionLang,
  setCustomerTranscriptionLang,
} from "@/features/cti2/transcription/speechRecognition";
import { AGENT_SPEECH_LANGUAGES } from "@/utilities/constant";

const isKnownCustomerLang = (code) =>
  !!code && AGENT_SPEECH_LANGUAGES.some((l) => l.code === code);

export const useTranscriptStore = create((set, get) => ({
  lines: [], // finalized: { speaker, source, text, timestamp, isFinal:true }
  interim: "",
  customerInterim: "",
  enabled: true,
  supported: isSpeechRecognitionSupported(),
  status: "idle", // idle | running | stopped | unsupported | error
  customerStatus: "idle",
  customerLang: getCustomerTranscriptionLang(),
  customerSupported: isSpeechRecognitionAudioTrackSupported(),
  agentLang: getTranscriptionLang(), // BCP-47 tag for the agent's Web Speech session
  agentMuted: false,
  error: null,

  addFinalLine: (text, { speaker = "Agent", source = "microphone" } = {}) => {
    if (!text) return;
    const isCustomer = speaker === "Customer";
    set((s) => ({
      lines: [
        ...s.lines,
        {
          speaker,
          source,
          text,
          timestamp: new Date().toISOString(),
          isFinal: true,
        },
      ],
      interim: isCustomer ? s.interim : "",
      customerInterim: isCustomer ? "" : s.customerInterim,
    }));
  },
  setInterim: (text) => set({ interim: text || "" }),
  setCustomerInterim: (text) => set({ customerInterim: text || "" }),
  setEnabled: (v) => set({ enabled: Boolean(v) }),
  setStatus: (status) => set({ status }),
  setCustomerStatus: (customerStatus) => set({ customerStatus }),
  setAgentMuted: (v) => {
    const muted = Boolean(v);
    set((s) => ({ agentMuted: muted, interim: muted ? "" : s.interim }));
  },
  setAgentLang: (agentLang) => {
    if (!agentLang || agentLang === get().agentLang) return;
    if (!setTranscriptionLang(agentLang)) return;
    set({ agentLang, interim: "", error: null });
  },
  setCustomerSupported: (v) => set({ customerSupported: Boolean(v) }),
  setCustomerLang: (customerLang) => {
    if (!isKnownCustomerLang(customerLang)) return;
    if (customerLang === get().customerLang) return;
    if (!setCustomerTranscriptionLang(customerLang)) return;
    set({ customerLang, customerInterim: "" });
  },
  setError: (error) =>
    set((s) => ({ error: error || null, status: error ? "error" : s.status })),
  reset: () =>
    set({
      lines: [],
      interim: "",
      customerInterim: "",
      status: "idle",
      customerStatus: "idle",
      agentMuted: false,
      error: null,
    }),
}));
